"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faHandPointUp = require("@fortawesome/pro-regular-svg-icons/faHandPointUp");

var _peractoConfig = require("@peracto/peracto-config");

var _Button = require("../../../components/Button");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Icon = function Icon() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex py-10 justify-center items-center w-full"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faHandPointUp.faHandPointUp,
    size: "6x"
  }));
};

var ButtonsComponent = function ButtonsComponent(_ref) {
  var _window, _window$location;

  var _ref$state = _ref.state,
      _ref$state$buttons = _ref$state.buttons,
      buttons = _ref$state$buttons === void 0 ? [] : _ref$state$buttons,
      _ref$state$direction = _ref$state.direction,
      direction = _ref$state$direction === void 0 ? 'row' : _ref$state$direction,
      _ref$state$justifyCon = _ref$state.justifyContent,
      justifyContent = _ref$state$justifyCon === void 0 ? 'flex-start' : _ref$state$justifyCon,
      _ref$state$spacing = _ref$state.spacing,
      spacing = _ref$state$spacing === void 0 ? 10 : _ref$state$spacing,
      _ref$state$selectedBu = _ref$state.selectedButtonIndex,
      selectedButtonIndex = _ref$state$selectedBu === void 0 ? null : _ref$state$selectedBu,
      isEditMode = _ref.isEditMode,
      onChange = _ref.onChange,
      focused = _ref.focused;
  var config = (0, _peractoConfig.useConfig)();
  var editorConfig = config.get('editorConfig');
  var buttonVariants = editorConfig === null || editorConfig === void 0 ? void 0 : editorConfig.buttonVariants;
  var inStorefront = !((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.pathname.includes('/content/edit/'));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (buttons === null || buttons === void 0 ? void 0 : buttons.length) > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex content__buttons",
    style: _objectSpread(_objectSpread({}, direction === 'row' && {
      flexDirection: 'row',
      justifyContent: justifyContent
    }), direction === 'column' && {
      flexDirection: 'column',
      alignItems: justifyContent
    })
  }, buttons.map(function (button, idx) {
    return /*#__PURE__*/_react["default"].createElement(_Button.Button, _extends({
      key: "btn_".concat(Math.floor(Math.random() * 10000)),
      className: "content__button disabled:opacity-[0.8] disabled:cursor-not-allowed max-w-full",
      href: button.url,
      style: {
        boxShadow: selectedButtonIndex === idx && focused && 'inset 0 0 0 3px yellow',
        marginLeft: idx > 0 && direction === 'row' && !['space-between', 'space-around'].includes(justifyContent) ? "".concat(spacing, "px") : 0,
        marginTop: idx > 0 && direction === 'column' && !['space-between', 'space-around'].includes(justifyContent) ? "".concat(spacing, "px") : 0,
        width: button.width === 'full' ? '100%' : 'auto'
      },
      variants: buttonVariants,
      variantColor: button.variant,
      variantStyle: button.style,
      size: button.size,
      onClick: function onClick(e) {
        if (isEditMode) {
          e.preventDefault();
          onChange({
            selectedButtonIndex: idx
          });
        }
      }
    }, button.openInNewTab && {
      target: '_blank'
    }), button.label);
  })) : inStorefront ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null) : /*#__PURE__*/_react["default"].createElement(Icon, null));
};

var _default = ButtonsComponent;
exports["default"] = _default;